var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 40,
    viewBox: "0 0 32 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_801_370)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9359 0H4.32447C2.01474 0 0.135742 1.80265 0.135742 4.01855V35.9815C0.135742 38.1973 2.01474 40 4.32447 40H26.947C29.2568 40 31.1357 38.1973 31.1357 35.9815V10.4189L18.9359 0ZM19.5667 3.15301L27.4456 9.88205H21.7204C20.5333 9.88205 19.5667 8.95469 19.5667 7.81583V3.15301ZM26.947 38.0477H4.32447C3.13738 38.0477 2.17075 37.1203 2.17075 35.9815V4.01855C2.17075 2.87969 3.13738 1.95233 4.32447 1.95233H17.5317V7.81583C17.5317 10.0317 19.4107 11.8344 21.7204 11.8344H29.1007V35.9815C29.1007 37.1203 28.1341 38.0477 26.947 38.0477Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3549 16.5687C15.9716 16.2043 15.2967 16.2043 14.9168 16.5687L8.71681 22.5168C8.31998 22.8975 8.31998 23.5158 8.71681 23.8965C8.91692 24.0885 9.17469 24.1828 9.43585 24.1828C9.69701 24.1828 9.95817 24.0885 10.1549 23.8965L14.6183 19.6144V31.5594C14.6183 32.0995 15.0728 32.5355 15.6358 32.5355C16.1989 32.5355 16.6534 32.0995 16.6534 31.5594V19.6144L21.1168 23.8965C21.5136 24.2772 22.1581 24.2772 22.5549 23.8965C22.9517 23.5158 22.9517 22.8975 22.5549 22.5168L16.3549 16.5687Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_801_370"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 40,
    fill: "white",
    transform: "translate(0.135742)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/File.ad04ba333095ebc512412a9cda967793.svg";
export { ForwardRef as ReactComponent };